import type { SectionsInstallStepsComponent } from '@twisto/api-cms'

import { InstallStep } from 'homepage/components/molecules/install-step'
import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './install-steps.styles'

export const InstallSteps = ({
  headline,
  highlighted,
  steps,
}: SectionsInstallStepsComponent) => {
  const { after, before, highlight } = useHighlightedText(
    headline || '',
    highlighted
  )

  return (
    <section css={styles.installSteps}>
      <div css={styles.container}>
        <h2 css={styles.headline}>
          {before}
          <span css={styles.highlighted}>{highlight}</span>
          {after}
        </h2>
        <div className="steps-container" css={styles.steps}>
          {steps?.map((step) => <InstallStep key={step.id} {...step} />)}
        </div>
      </div>
    </section>
  )
}
